var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-product-group-select-autcomplete',{attrs:{"value":_vm.value,"light":_vm.light,"use-id":""},on:{"group":function($event){return _vm.onInputGroup($event)},"subgroup":function($event){return _vm.onInputSubGroup($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }